import React, { useState, useEffect, Fragment } from "react";
import { Loader } from "../../../components/Loader";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import {
  useCheckoutContext,
} from "../../../context/checkout/CheckoutContext";
import {
  CartEntity,
  LeftOrRight,
  Customer,
} from "../../../models/cartData";
import { Checkout } from "../../checkoutCart/components/Checkout";
import { AccessoriesBoxes } from "./AccessoriesBoxes";
import { BillingData } from "./BillingData";
import { CashOnDelivery } from "./CashOnDelivery";
import { ColorPlano } from "./ColorPlano";
import { ColorPowers } from "./ColorPowers";
import Coupon from "./Coupon";
import CouponApplied from "./CouponApplied";
import { CustomerWallet } from "./CustomerWallet";
import { EditButton } from "./EditButton";
import EstimateDelivery from "./EstimateDelivery";
import FreeVariant from "./FreeVariant";
import LineItemHead from "./LineItemHead";
import { MedicalPowers } from "./MedicalPowers";
import PlaceOrderCTA from "./PlaceOrderCTA";
import { SolutionBoxes } from "./SolutionBoxes";
import { ToricPowers } from "./ToricPowers";
import { TotalDiscount } from "./TotalDiscount";
import { GoldMember } from "./GoldMember";
import AddressForm from "./AddressForm";
import AddNewAddress from "./AddNewAddress";
import Cookies from "js-cookie";
import empty_cart from "../../../assets/lottie/empty_cart.json";
import Lottie, { useLottie } from "lottie-react";
import NeedHelp from "./NeedHelp";
import OneDayDelivery from "./OneDayDelivery";
import TrialProduct from "./TrialColorPlano";
import { TrialMedicalPowers } from "./TrialMedicalPowers";
import { TrialToricPowers } from "./TrialToricPowers";
import { TrialColorPowers } from "./TrialColorPowers";
import TrialColorPlano from "./TrialColorPlano";
import { viewCartEvent } from "../../../utils/GoogleAnalytics";

interface cartdataProps {
  data: CartEntity[];
  customer: Customer;
}


function CartData() {

  const cookieCartIdValue = Cookies.get("cartId");
  const oneDayDelivery = Cookies.get("utmSource");

  const getCartIdFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let cartId = null;
    if (urlParams.has("cartId")) {
      cartId = urlParams.get("cartId");
    }
    return cartId;
  };
  //let bearerToken = null;
  const cartIdData = () => {
    let cartId = null;
    cartId = getCartIdFromURL();
    if (cartId == null) {
      cartId = cookieCartIdValue;
    }
    return cartId;
  };

  const {
    fetchCart,
    getCartData,
    statusData,
    getCustomerCoupons,
    getCouponData,
    modalOpenData,
    selectedAddressData,
    gerCartError,
    setError
  } = useShoppingCart();

  const { createCart, getCheckoutError } = useCheckoutContext();
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const apiURL = process.env.REACT_APP_API_URL;



  // console.log(isCartLoadingData, "isCartLoadingData");

  useEffect(() => {
    fetchCart().then(
      (cartData: React.SetStateAction<cartdataProps | null | undefined>) => {
      getCustomerCoupons();

      }
      
    );
  }, []);

  

  const data = getCartData;
  const billing_data = data?.data[0].billing_data;
  const cartCount = data?.data[0].cart_item_count;
  const coupon_discount = data?.data[0].coupon_discount;
  const cart_id = data?.data[0].id;
  const customer_wallet = data?.data[0].customer.customer_wallet;
  const address = data?.data[0].address;
  const is_cod = data?.data[0].is_cod;
  const wallet_amount = billing_data?.wallet_amount;
  const gold_member = data?.data[0].is_gold;
  const gold_discount = data?.data[0].gold_discount;
  const gold = gold_discount?.gold;
  const gold_variant = gold_discount?.gold_variant;
  const gold_variant_price = gold_discount?.gold_variant_price;
  const is_gold_member = gold_discount?.is_gold_member;
  const is_lk_gold_member = gold_discount?.is_lk_gold_member;
  const gold_free_item = gold_discount?.gold_free_item;



  
  // console.log(address);
  let addressFlag = false;
  if (address !== null) {
    addressFlag = true;
  }

  // useEffect(() => {
  //   getCustomerCoupons();
  // }, []);

  const couponData: any = getCouponData;
  // const noOfCoupon: number = couponData?.data?.customer_coupons?.length;
  let noOfCoupon:number = 0;
  if (couponData?.data?.customer_coupons) {
    couponData.data.customer_coupons.forEach((item: { enable: boolean; }) => {
      if (item.enable == true) {
        noOfCoupon++;
      }
    });
  }



  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: empty_cart,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const { View } = useLottie(defaultOptions);

  const isScreenSizeGreaterThan749px = window.innerWidth > 749;
  const isScreenSizeLessThan749px = window.innerWidth < 749;
  const [isClose, setIsClose] = useState(false);

  useEffect(() => {
    if (getCheckoutError && getCheckoutError !== 'success') {
      setIsClose(true);
    } else {
      setIsClose(false);
    }
}, [getCheckoutError]);


const [errorPopupClose, setErrorPopupClose] = useState(true);

useEffect(() => {
if(gerCartError === ''){
  setErrorPopupClose(true);
}
}, [gerCartError]);


useEffect(() => {
  document.body.style.overflow = modalOpenData.isPopup ? 'hidden' : 'unset';

  return () => {
    document.body.style.overflow = 'unset';
  };
}, [modalOpenData.isPopup]);





const[ fix , setFix ] = useState(false)
function setFixedSideBar(){
  if(window.scrollY >= 500 ){
    setFix(true)
  }else {
    setFix(false)

  }
}
window.addEventListener("scroll",setFixedSideBar)


const [isProductTrial, setIsProductTrial] = useState(false);
const tempCartItems = data?.data[0]?.temp_cart_items;

let cart_item_array:any = [];

    useEffect(() => {
        if (tempCartItems && tempCartItems.length > 0) {
            const isTrialProductFound = tempCartItems.some(item => item.is_trial === 1);
            if (isTrialProductFound) {
                setIsProductTrial(true);
            }
        }
    }, [tempCartItems]);

    let order_content = 'product';
      if (tempCartItems && tempCartItems.length > 0) {  
        for (var x in tempCartItems) {

          let power_type = ''
          if(tempCartItems[x]?.has_power == 1){
            power_type = 'power'
          }else{
            power_type = 'zero power'
          }

          // if(tempCartItems[x]?.product_type == 'gold_member'){
          //   order_content += '& membership'
          // }else if(tempCartItems[x]?.product_type == 'gold_member' && x == 0){
          //   order_content = 'membership'
          // }

          if (tempCartItems[x]?.product_type == 'gold_member') {
            if (parseInt(x) === 0) { // Convert x to a number explicitly
              order_content = 'membership';
            } else {
              order_content += ' & membership';
            }
          }

          cart_item_array.push({
            item_name: tempCartItems[x]?.product_title,
            item_id: tempCartItems[x]?.id,
            index: x,
            item_brand: 'Aqualens',
            item_category: tempCartItems[x]?.product_type,
            item_category2: tempCartItems[x]?.title,
            item_category3: tempCartItems[x]?.subtitle,
            power_type: power_type,
            sph_left_eye_power: tempCartItems[x]?.prescription?.left?.sph,
            sph_right_eye_power: tempCartItems[x]?.prescription?.right?.sph,
            left_eye_boxes: tempCartItems[x]?.prescription?.left?.boxes,
            right_eye_boxes: tempCartItems[x]?.prescription?.right?.boxes,
            additional_left_eye_power: tempCartItems[x]?.prescription?.left?.ap,
            additional_right_eye_power: tempCartItems[x]?.prescription?.right?.ap,
            cyl_left_eye_power: tempCartItems[x].prescription?.left?.cyl,
            cyl_right_eye_power: tempCartItems[x].prescription?.right?.cyl,
            axis_left_eye: tempCartItems[x]?.prescription?.left?.axis,
            axis_right_eye:tempCartItems[x]?.prescription?.right?.axis,
            item_list_id: tempCartItems[x]?.temp_cart_id,
            item_list_name:tempCartItems[x]?.product_type,
            item_variant: tempCartItems[x]?.variant_title,
            price: tempCartItems[x]?.price,
            quantity: tempCartItems[x]?.quantity

          });
        }
      }

   

      

   

    
  return (
    <>
      {/* < HomeSkeleton cards={8}/> */}
      {/* <Loader /> */}
      {/* <CartLoader /> */}
      {/* <AquaLoader /> */}
      {/* { statusData === 'loading' && && <ModalLoader /> } */}



      {getCheckoutError && getCheckoutError !== '' && isClose &&
             <div className="couponSuccessBackdrop">
                <div className="couponBackdeop">
                    <div>{getCheckoutError}</div>
                        <button className='closeErrorButton' style={{fontSize:'16px'}} onClick={() => { setIsClose(false) }}>Close</button>
                </div>
            </div>}

      {statusData === "failed" &&  gerCartError !== '' && errorPopupClose && (
        <div className="errorConetntBackground">
          <div className="errorModalContainer">
            <div></div>
            <div style={{ textAlign: "center" }}>
              <h2 className="errorMessage">{gerCartError}</h2>
              <button
                onClick={ () => { setError();  setErrorPopupClose(false); }}
                style={{
                  color: "white",
                  background: 'rgb(61, 106, 174)',
                  padding: '5px 20px',
                  borderRadius: '4px',
                  fontSize: '16px'
                  // textDecoration: "underline",
                }}
              >
               Ok
              </button>
            </div>
          </div>
        </div>
      )}

      {statusData === "loading" && <Loader />}
     

      {/* <Loader /> */}
      {data && data.data[0].temp_cart_items?.length !== 0 ? (
        <div
          style={{ width: "100%", background: "#F8F9F9", paddingTop: "2px" }}
        >
          <div className="cart_wrapper">
            {/* <div className="cartHeading">Cart</div> */}

            <div className="cart_left_flex">
              {/* estimate delivery */}
              {/* {data && address &&
                            <Address address={address} />
                        } */}

              {/* estimate delivery */}
              {data && address && address !== null ? (
                <>
                
                  {/* <AddNewAddress /> */}
                  <EstimateDelivery
                    address={address.address}
                    city={address.city}
                    zip_code={address.zip}
                    phone={address.phone}
                    first_name={address.first_name}
                    cart_id={cart_id}
                  />
                </>
              ) : (
                <AddNewAddress />
              )}

              {/* billing data */}
              {data && billing_data && billing_data.total_discount > 0 &&  isScreenSizeLessThan749px &&(
                <TotalDiscount
                  total_discount={billing_data.total_discount}
                  wallet_amount={billing_data.wallet_amount}
                />
              )}

              {/* { oneDayDelivery && oneDayDelivery !== '' && 
                <OneDayDelivery />
              } */}

              <>
                {/* line item section */}
                {data &&
                  data.data[0].temp_cart_items?.length != 0 &&
                  data.data[0].temp_cart_items?.map((item) => (
                    <div className="container lineItemContainer" key={item.variant_id}>
                      <div
                        className={
                          item.is_free === 0
                            ? "cartLineItemCard"
                            : "freeCardLineItem"
                        }
                      >
                        {/* line item head */}
                        {item.is_free === 0 ? (
                          <LineItemHead
                            item_image={item.item_image}
                            title={item.title}
                            subtitle={item.subtitle}
                            price={item.price}
                            variant_title={item.variant_title}
                            variant_id={item.variant_id}
                            cart_id={cart_id}
                            temp_cart_id={item.id}
                            product_type={item.product_type}
                            power_type={item.has_power}
                            product_title = {item.product_title}
                          />
                        ) : (
                          <FreeVariant
                            item_image={item.item_image}
                            title={item.product_title}
                            subtitle={item.subtitle}
                            price={item.price}
                            variant_title={item.variant_title}
                            is_free_xmember={item.is_free_xmember}
                            variant_id={item.variant_id}
                            cart_id={cart_id}
                            temp_cart_id={item.id}
                            product_type={item.product_type}
                            power_type={item.has_power}
                            product_title = {item.product_title}
                          />
                        )}

                        <EditButton />
                        {/* Prescription data */}

                        {item.has_power === 0 && (
                          <>
                            {item.product_type === "colorLens" && item.is_free === 0 && (
                              <ColorPlano
                                power_type="Zero Power"
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                boxes={item.prescription?.left?.boxes}
                                item_image={item.item_image}
                                variant_title={item.variant_title}
                                price={item.price}
                                compare_at_price = {item.compare_at_price}
                              />
                            )}
                            
                            {item.product_type === "trial" && item.product_subtype === "colorLens" && item.is_free === 0 && (
                              <TrialColorPlano
                                power_type="Zero Power"
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                boxes={item.prescription?.left?.boxes}
                                item_image={item.item_image}
                                variant_title={item.variant_title}
                                price={item.price}
                                compare_at_price = {item.compare_at_price}
                              />
                            )}


                            {item.product_type === "Solution" &&
                            item.is_free === 0 ? (
                              <SolutionBoxes
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                boxes={item.quantity}
                                price={item.price}
                                compare_at_price = {item.compare_at_price}
                              />
                            ) : (
                              ""
                            )}
                            {item.product_type === "Accessories" && item.is_free === 0 && (
                              <AccessoriesBoxes
                                boxes={item.quantity}
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                price={item.price}
                                compare_at_price = {item.compare_at_price}
                              />
                            )}

                            
                          </>
                        )}

                        {item.has_power === 1 && (
                          <>
                            {item.product_type === "Medical" && item.is_free === 0 && (
                              <MedicalPowers
                                power_type="Power"
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                left_boxes={item.prescription?.left?.boxes}
                                right_boxes={item.prescription?.right?.boxes}
                                left_sph={item.prescription?.left?.sph}
                                right_sph={
                                  item.prescription?.right
                                    ? item.prescription?.right?.sph
                                    : undefined
                                }
                                price={item.price}
                                right={item.prescription?.right ? true : false}
                                left={item.prescription?.left ? true : false}
                                ap_left={item.prescription?.left?.ap}
                                is_apLeft={item.prescription?.left?.ap ? true : false}
                                ap_right={item.prescription?.right?.ap}
                                is_apRight = { item.prescription?.right?.ap ? true : false}
                                compare_at_price = {item.compare_at_price}

                              />
                            )}

                          {item.product_type === "trial" && item.product_subtype === "Medical" &&  item.is_free === 0 && (
                              <TrialMedicalPowers
                                power_type="Power"
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                left_boxes={item.prescription?.left?.boxes}
                                right_boxes={item.prescription?.right?.boxes}
                                left_sph={item.prescription?.left?.sph}
                                right_sph={
                                  item.prescription?.right
                                    ? item.prescription?.right?.sph
                                    : undefined
                                }
                                price={item.price}
                                right={item.prescription?.right ? true : false}
                                left={item.prescription?.left ? true : false}
                                ap_left={item.prescription?.left?.ap}
                                is_apLeft={item.prescription?.left?.ap ? true : false}
                                ap_right={item.prescription?.right?.ap}
                                is_apRight = { item.prescription?.right?.ap ? true : false}
                                compare_at_price = {item.compare_at_price}

                              />
                            )}

                            {item.product_type === "toric" &&  item.is_free === 0 && (
                              <ToricPowers
                                power_type="Power"
                                variant_id={item.variant_id}
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                left_boxes={item.prescription?.left?.boxes}
                                right_boxes={item.prescription?.right?.boxes}
                                left_sph={item.prescription?.left.sph}
                                right_sph={
                                  item.prescription?.right
                                    ? item.prescription?.right?.sph
                                    : undefined
                                }
                                left_cyl={item.prescription?.left?.cyl}
                                right_cyl={item.prescription?.right?.cyl}
                                left_axis={item.prescription?.left?.axis}
                                right_axis={item.prescription?.right?.axis}
                                price={item.price}
                                right={item.prescription?.right ? true : false}
                                left={item.prescription?.left ? true : false}
                                compare_at_price = {item.compare_at_price}
                              />
                            )}

                            {item.product_type === "trial" && item.product_subtype === "toric" &&  item.is_free === 0 && (
                              <TrialToricPowers
                                power_type="Power"
                                variant_id={item.variant_id}
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                left_boxes={item.prescription?.left?.boxes}
                                right_boxes={item.prescription?.right?.boxes}
                                left_sph={item.prescription?.left.sph}
                                right_sph={
                                  item.prescription?.right
                                    ? item.prescription?.right?.sph
                                    : undefined
                                }
                                left_cyl={item.prescription?.left?.cyl}
                                right_cyl={item.prescription?.right?.cyl}
                                left_axis={item.prescription?.left?.axis}
                                right_axis={item.prescription?.right?.axis}
                                price={item.price}
                                right={item.prescription?.right ? true : false}
                                left={item.prescription?.left ? true : false}
                                compare_at_price = {item.compare_at_price}
                              />
                            )}
                            {item.product_type === "colorLens" && item.is_free === 0 && (
                              <ColorPowers
                                power_type="Power"
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                left_boxes={item.prescription?.left?.boxes}
                                right_boxes={item.prescription?.right?.boxes}
                                item_image={item.item_image}
                                variant_title={item.variant_title}
                                left_sph={item.prescription?.left?.sph}
                                right_sph={item.prescription?.right?.sph}
                                price={item.price}
                                right={item.prescription?.right ? true : false}
                                left={item.prescription?.left ? true : false}
                                compare_at_price = {item.compare_at_price}
                              />
                            )}

                          { item.product_type === "trial" && item.product_subtype === "colorLens" && item.is_free === 0 && (
                              <TrialColorPowers
                                power_type="Power"
                                cart_id={cart_id}
                                temp_cart_id={item.id}
                                left_boxes={item.prescription?.left?.boxes}
                                right_boxes={item.prescription?.right?.boxes}
                                item_image={item.item_image}
                                variant_title={item.variant_title}
                                left_sph={item.prescription?.left?.sph}
                                right_sph={item.prescription?.right?.sph}
                                price={item.price}
                                right={item.prescription?.right ? true : false}
                                left={item.prescription?.left ? true : false}
                                compare_at_price = {item.compare_at_price}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  ))}
              </>

              {/* Free Variant */}
              {/* {free_variant && free_variant != null &&
                                <FreeVariant item_image={free_variant.item_image} title={free_variant.product_title} subtitle={free_variant.subtitle} price={free_variant.price} variant_title={free_variant.variant_title} />
                            } */}
            </div>

            <div className="cart_right_flex" >
              <div className="cart_right_flex_fixed">
              <div className="flex billing_data">
                <div className="cart_wrapper_flex_right">
                {isProductTrial === false ? (
                  <>
                  {data && coupon_discount && coupon_discount !== null ? (
                    <CouponApplied
                      amount_off={coupon_discount.amount_off}
                      cashback={coupon_discount.cashback}
                      free_variant_price={coupon_discount.free_variant_price}
                      coupon={coupon_discount.coupon}
                      message={coupon_discount.enable_message}
                      cart_id={cart_id}
                    />
                  ) : (

                    <Coupon cart_id={cart_id} noOfCoupon={noOfCoupon} />

                  )}
                  </>
                ) : '' }


                  {/* coupon section */}

                  {/* {data && coupon_discount &&
                                <CouponApplied
                                    amount_off={coupon_discount.amount_off}
                                    coupon={coupon_discount.coupon}
                                    message={coupon_discount.message}
                                    cart_id={cart_id}
                                />

                            } */}

                  {/* wallet section */}
                  {isProductTrial === false ? (
                  <>
                  {data && billing_data &&customer_wallet && 
                    customer_wallet != null &&
                    Number(customer_wallet.wallet_balance) > 0 && (
                      <CustomerWallet
                        cart_id={cart_id}
                        wallet_balance={Number(customer_wallet.wallet_balance)}
                        wallet_id={customer_wallet.id}
                        wallet_type={customer_wallet.wallet_type}
                        wallet_amount={wallet_amount}
                        total={billing_data.total}

                      />
                    )}
                  </>
                  ) : '' }

                  {/* CashOnDelivery */}
                  {isProductTrial === false ? (
                  <>
                  {data && billing_data && (
                    <CashOnDelivery
                      cart_id={cart_id}
                      cod={is_cod}
                      shipping_charge={billing_data.shipping_charge}
                      total={billing_data.total}
                      gold_free_item={gold_free_item}
                      gold_variant={gold_variant}
                      is_gold_member={is_gold_member}
                      is_lk_gold_member={is_lk_gold_member}


                    />
                  )}
                  </>
                  ) : '' }

                </div>
                <div className="cart_wrapper_flex_right">

                {isProductTrial === false ? (
                  <>
                  {data && billing_data && gold_member === 0 && (
                    <GoldMember total={billing_data.total} cart_id={cart_id} gold={gold}  />
                  )}
                </>
                ) : '' }

            

                  {data && billing_data && billing_data.total_discount > 0 && isScreenSizeGreaterThan749px && (
                                  <TotalDiscount
                                    total_discount={billing_data.total_discount}
                                    wallet_amount={billing_data.wallet_amount}
                                  />
                                )}

                  {/* billing section */}
                  {data && billing_data && (
                    <BillingData
                      amount_off={billing_data.amount_off}
                      bmsm_discount={billing_data.bmsm_discount}
                      cashback={billing_data.cashback}
                      free_variant_price={billing_data.free_variant_price}
                      gold_discount={billing_data.gold_discount}
                      gold_variant_price={billing_data.gold_variant_price}
                      item_total={billing_data.item_total}
                      total={billing_data.total}
                      total_discount={billing_data.total_discount}
                      wallet_amount={billing_data.wallet_amount}
                      cart_count={cartCount}
                      cart_id={cart_id}
                      cod={is_cod}
                      shipping_charge={billing_data.shipping_charge}
                      is_gold_member={is_gold_member}
                      is_lk_gold_member={is_lk_gold_member}
                      gold={gold}
                    />
                  )}
                </div>
              </div>

             
              {/*  Proceed CTA */}
              {data && billing_data && (
                <PlaceOrderCTA
                  addressFlag={addressFlag}
                  total={addressFlag === true ? billing_data.total : ""}
                  cart_id={cart_id}
                  buttton_text={
                    addressFlag === true ? "Proceed To Order" : "Add Address"
                  }
                  onPress={createCart}
                  setOpenCheckout={setCheckoutOpen}                
                />
              )}
              <NeedHelp />
</div>
            </div>
          </div>
        </div>
      ) : (
       
        <div  style={{
          padding: "100px",
        }}>
          <div
          style={{
            textAlign: "center",
            maxWidth: "500px",
            width: "90%",
            margin: "auto",
          }}
          >
          {/* <div className='emptyCartIcon'>{ View }</div> */}
          <p>Your Cart is Empty</p>
          <div
            className="continueShopping ripple"
            style={{ marginTop: "20px" }}
          >
            <a href="https://aqualens.in/">Continue Shopping</a>
          </div>
          </div>
        </div>
      )}

      {modalOpenData &&
        modalOpenData.isPopup === true &&
        modalOpenData.popupId === "checkout" && <Checkout />}
      {modalOpenData &&
        modalOpenData.isPopup === true &&
        modalOpenData.popupId === "addressForm" && (
          // <AddressForm selectedAddress={selectedAddressData} />
          <div className="modalBackground ">
            <div className="modalContainer">
              <AddressForm selectedAddress={selectedAddressData} />
            </div>
          </div>
        )}
    </>
  );
}

export default CartData;
